/**
 * Pass de malla (Modo C): preview alineada a la caja N³ sin Three/GLTFLoader
 * (CRA no exporta GLTFLoader desde 'three' y el bundle de three pide `process`).
 * El visor no hace Marching Cubes; un GLB del servidor se acota aquí con un AABB.
 */
import React, { Component } from 'react'
import { mpr3dGridToWorld, mpr3dProjectToUv } from '../utils/mpr3dCamera'

export default class Mpr3dMeshOverlay extends Component {
  constructor(props) {
    super(props)
    this.ref = React.createRef()
  }

  componentDidMount() {
    this.paint()
  }

  componentDidUpdate() {
    this.paint()
  }

  paint = () => {
    const canvas = this.ref.current
    if (!canvas) return
    const parent = canvas.parentElement
    const cssW = Math.max(32, (parent && parent.clientWidth) || 256)
    const cssH = Math.max(32, (parent && parent.clientHeight) || 256)
    if (canvas.width !== cssW) canvas.width = cssW
    if (canvas.height !== cssH) canvas.height = cssH
    const ctx = canvas.getContext('2d')
    if (!ctx) return
    ctx.clearRect(0, 0, cssW, cssH)

    const vol = this.props.volume
    const n = vol && vol.size ? vol.size : 32
    const box = this.props.isolateBox
    const c = (box && box.centroid) || { x: (n - 1) * 0.5, y: (n - 1) * 0.5, z: (n - 1) * 0.5 }
    const min = (box && box.min) || { x: c.x - n * 0.08, y: c.y - n * 0.08, z: c.z - n * 0.08 }
    const max = (box && box.max) || { x: c.x + n * 0.08, y: c.y + n * 0.08, z: c.z + n * 0.08 }
    const corners = [
      [min.x, min.y, min.z],
      [max.x, min.y, min.z],
      [max.x, max.y, min.z],
      [min.x, max.y, min.z],
      [min.x, min.y, max.z],
      [max.x, min.y, max.z],
      [max.x, max.y, max.z],
      [min.x, max.y, max.z],
    ]
    const cam = {
      yaw: Number(this.props.yaw) || 0,
      pitch: this.props.pitch != null ? Number(this.props.pitch) : 0.18,
      zoom: Math.max(0.35, Number(this.props.zoom) || 1),
      aspect: cssH > 0 ? cssW / cssH : 1,
    }
    const pts = corners.map(([x, y, z]) => {
      const w = mpr3dGridToWorld(x, y, z, n, vol && vol.boxScale)
      const uv = mpr3dProjectToUv(w, cam)
      if (!uv) return null
      return { x: uv.x * cssW, y: uv.y * cssH }
    })
    const edges = [
      [0, 1], [1, 2], [2, 3], [3, 0],
      [4, 5], [5, 6], [6, 7], [7, 4],
      [0, 4], [1, 5], [2, 6], [3, 7],
    ]
    ctx.strokeStyle = 'rgba(80, 230, 190, 0.9)'
    ctx.lineWidth = 1.5
    ctx.beginPath()
    edges.forEach(([a, b]) => {
      if (!pts[a] || !pts[b]) return
      ctx.moveTo(pts[a].x, pts[a].y)
      ctx.lineTo(pts[b].x, pts[b].y)
    })
    ctx.stroke()
  }

  render() {
    if (!this.props.url && !this.props.isolateBox) return null
    return (
      <canvas
        ref={this.ref}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 2,
          pointerEvents: 'none',
          width: '100%',
          height: '100%',
        }}
      />
    )
  }
}
